import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ErrorBoundary } from './components/ErrorBoundary';

// Office Pages
import Login from './pages/office/Login';
import Dashboard from './pages/office/Dashboard';
import CreateRecord from './pages/office/CreateRecord';
import ActiveRecords from './pages/office/ActiveRecords';
import RecordDetail from './pages/office/RecordDetail';
import Archive from './pages/office/Archive';
import EmailExceptions from './pages/office/EmailExceptions';
import Staff from './pages/office/Staff';
import UserProfiles from './pages/office/UserProfiles';

// Driver Pages
import DriverJobs from './pages/driver/DriverJobs';
import DriverJobDetail from './pages/driver/DriverJobDetail';

import './App.css';

function AppRoutes() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#F5F5F5]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-[#0D9488] border-t-transparent mx-auto mb-4"></div>
          <p className="text-sm text-[#6B7280]">Loading CargoDash...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={user ? <Navigate to={user.role === 'driver' ? '/driver/jobs' : '/dashboard'} /> : <Login />} />
      <Route path="/driver/login" element={user ? <Navigate to={user.role === 'driver' ? '/driver/jobs' : '/dashboard'} /> : <Login />} />

      {/* Office */}
      <Route path="/dashboard" element={<ProtectedRoute allowedRoles={['admin', 'office_staff']}><Dashboard /></ProtectedRoute>} />
      <Route path="/create-record" element={<ProtectedRoute allowedRoles={['admin', 'office_staff']}><CreateRecord key={location.key} /></ProtectedRoute>} />
      <Route path="/active-records" element={<ProtectedRoute allowedRoles={['admin', 'office_staff']}><ActiveRecords /></ProtectedRoute>} />
      <Route path="/record/:id" element={<ProtectedRoute allowedRoles={['admin', 'office_staff']}><RecordDetail /></ProtectedRoute>} />
      <Route path="/archive" element={<ProtectedRoute allowedRoles={['admin', 'office_staff']}><Archive /></ProtectedRoute>} />
      <Route path="/email-exceptions" element={<ProtectedRoute allowedRoles={['admin', 'office_staff']}><EmailExceptions /></ProtectedRoute>} />
      <Route path="/staff" element={<ProtectedRoute allowedRoles={['admin']}><Staff /></ProtectedRoute>} />
      <Route path="/drivers" element={<ProtectedRoute allowedRoles={['admin']}><Staff /></ProtectedRoute>} />
      <Route path="/user-profiles" element={<ProtectedRoute allowedRoles={['admin']}><UserProfiles /></ProtectedRoute>} />

      {/* Driver */}
      <Route path="/driver/jobs" element={<ProtectedRoute allowedRoles={['driver']}><DriverJobs /></ProtectedRoute>} />
      <Route path="/driver/job/:id" element={<ProtectedRoute allowedRoles={['driver']}><DriverJobDetail /></ProtectedRoute>} />

      {/* Default */}
      <Route path="*" element={
        user
          ? <Navigate to={user.role === 'driver' ? '/driver/jobs' : '/dashboard'} />
          : <Navigate to="/login" />
      } />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
